(ns app.gis.util
  (:require [clojure.string :as str]))


(defn wms-proxy-url
  [server-config-id wms-service-path]
  (str "/api/command/gis/wms-proxy/"
       server-config-id
       (when (and (seq wms-service-path)
                  (not (str/starts-with? wms-service-path "/")))
         "/")
       wms-service-path))


(defn wms-wfs-service-full-path
  [server-url service-path]
  (str server-url
       (when (and (seq service-path)
                  (not (str/ends-with? server-url "/"))
                  (not (str/starts-with? service-path "/")))
         "/")
       service-path))
